import { createFileRoute, redirect } from '@tanstack/react-router';

import { CertificatePrintPage } from '@/features/commercial/certificate-print-page';
import { bootSession } from '@/lib/auth/session';

/** Outside the app shell on purpose: the payment certificate for the browser's print / Save as PDF. */
export const Route = createFileRoute('/print/projects/$projectId/certificates/$certificateId')({
  beforeLoad: async ({ location }) => {
    const session = await bootSession();
    if (session.status === 'signed_out') {
      throw redirect({ to: '/signin', search: { return_to: location.href } });
    }
  },
  component: PrintRoute,
});

function PrintRoute() {
  const { projectId, certificateId } = Route.useParams();
  return <CertificatePrintPage projectId={projectId} certificateId={certificateId} />;
}
